module.exports = __webpack_public_path__ + "img/developers--avatar.96f2e04b.svg";